import theme from "@/theme";

export function alternatingRowBg(index: number) {
  return index % 2 === 0
    ? "white"
    : theme.palette.background["paper-elevation-0"];
}

export interface TableHeadCell {
  id: string;
  name: string;
  sortable: boolean;
  align?: "right";
}
